import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Bookmark, ChevronDown } from "lucide-react";
import { CASA_PRONTA_BOOKMARKLET, CASA_PRONTA_URL } from "@/lib/casaProntaBookmarklet";

export function CasaProntaFavorito() {
  const [open, setOpen] = useState(false);
  const link = useRef(null);
  useEffect(() => { link.current?.setAttribute("href", CASA_PRONTA_BOOKMARKLET); }, [open]);
  return (
    <div className="rounded-lg border border-slate-200 bg-white" data-testid="cp-favorito">
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between gap-2 px-3 py-2 text-xs font-semibold text-slate-600" data-testid="cp-favorito-toggle">
        Primeira vez? Instalar o favorito «Preencher ImoDesk»
        <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-3">
          <ol className="text-xs text-slate-600 space-y-1.5 list-decimal pl-5">
            <li>Mostre a barra de favoritos do navegador (Chrome/Edge: Ctrl+Shift+B · Mac: ⌘+Shift+B).</li>
            <li>Arraste o botão abaixo para a barra de favoritos.</li>
            <li>Carregue em «Copiar para o Casa Pronta».</li>
            <li>Abra o <a href={CASA_PRONTA_URL} target="_blank" rel="noreferrer" className="text-ec-green underline">formulário Novo Anúncio do Casa Pronta</a> e carregue no favorito.</li>
            <li>Reveja todos os campos antes de carregar em «Continuar».</li>
          </ol>
          <a ref={link} onClick={(e) => { e.preventDefault(); toast.info("Arraste este botão para a barra de favoritos."); }} data-testid="cp-bookmarklet" draggable
            className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-ec-gold text-ec-green font-semibold text-xs cursor-grab shadow-sm">
            <Bookmark size={14} /> Preencher ImoDesk
          </a>
          <p className="text-[11px] text-slate-400">O favorito só preenche o formulário: não envia nem paga nada. Os dados do requerente vêm de Definições da agência › Agência.</p>
        </div>
      )}
    </div>
  );
}
